import type { Translatable } from "app/pages/sales-intelligence/types";

export const DEFAULT_SEARCH_NAME: Readonly<Translatable> = {
    key: "si.components.save_new_search_modal.text_field.default_value",
};
